import { Fragment } from 'react';
import clsx from 'clsx';

import { Collapse as MuiCollapse, styled, TableRow as MuiTableRow } from '@mui/material';

import { TableCell } from '../TableCell';
import { tableRowClasses } from './theme';

import type { TableRowOwnerState, TableRowProps } from './types';

const TableRow = (props: TableRowProps) => {
  const {
    open = false,
    collapse = false,
    collapseProps,
    children,
    className,
    selected,
    subRow = false,
    onClick,
    onContextMenu,
    ...others
  } = props;
  const {
    colSpan,
    renderRow,
    unmountOnExit = true,
  } = collapseProps ?? { colSpan: 1, renderRow: () => null, unmountOnExit: false };

  const ownerState: TableRowOwnerState = { ...props, open, collapse };

  return (
    <Fragment>
      <MuiTableRow
        selected={selected}
        onClick={onClick}
        onContextMenu={onContextMenu}
        className={clsx(className, subRow && tableRowClasses.subRow)}
        {...others}
      >
        {children}
      </MuiTableRow>
      {collapse && renderRow && (
        <TableRowCollapse
          {...others}
          hover={false}
          ownerState={ownerState}
          className={clsx(open && tableRowClasses.open)}
        >
          <TableCell colSpan={colSpan}>
            <MuiCollapse
              in={open}
              timeout={'auto'}
              unmountOnExit={unmountOnExit}
              classes={{ wrapperInner: tableRowClasses.collapseContent }}
            >
              {renderRow(open)}
            </MuiCollapse>
          </TableCell>
        </TableRowCollapse>
      )}
    </Fragment>
  );
};

export default TableRow;

const TableRowCollapse = styled(MuiTableRow, {
  target: tableRowClasses.collapse,
})<{ ownerState: TableRowOwnerState }>``;
